import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Row, Col, Card, Modal, Form, Button } from "react-bootstrap";
import EstimatedTimePage from "../EstimatedTimeCustomersSpend";
import styled from "styled-components";
import SubMenu from "../SubMenu";
import Separator from "../Separator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faChair,
  faGear,
  faCircleXmark,
  faEnvelope,
  faSquarePhoneFlip,
  faKey,
  faMessage,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { getDialCode, getCountryCode } from "../CountryCode";
import WaitCheckMark from "../WaitCheckMark";
import SwitchOnAndOff from "../SwitchOnAndOff";
import {
  getRestaurantNotificationsList,
  createRestaurantNotificationsList,
  updateRestaurantNotificationsList,
  fetchRestaurantDetails,
} from "../../actions/restaurantActions";
import { api } from "../../App";
import {
  ContainerBox,
  Header,
  Body,
  OrangeButton,
  Title,
  Container,
  CardHeader,
  CardHeaderTitle,
  ModernTextInput,
  ModernButton,
} from "../DefaultImports";

import "react-phone-input-2/lib/style.css"; // Import the default CSS for react-phone-input-2
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"; // Import the Bootstrap CSS for additional styling
import { CustomModal } from "../CustomModal";
import { ConfirmationModal } from "../ConfirmationModal";
import PhoneField from "../PhoneField";

function RestaurantNotifications() {
  const dispatch = useDispatch();
  const params = useParams();
  const [itemId, setItemId] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [emailWM, setEmailWM] = useState(false);
  const [phoneWM, setPhoneWM] = useState(false);
  const [email_or_whatsapp, setEmail_or_whatsapp] = useState("");
  const [update_or_create, setUpdate_or_create] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);

  const [restaurant_id, setRestaurant_id] = useState(false);

  // comunication types
  const [useEmail, setUseEmail] = useState(false);
  const [useSms, setUseSms] = useState(false);
  const [useWhatsapp, setUseWhatsapp] = useState(false);

  const [isCheckedSendAcceptance, setIsCheckedSendAcceptance] = useState(false);
  const [isCheckedSendCancel, setIsCheckedSendCancel] = useState(false);
  const [isCheckedSendCodeToConfirm, setIsCheckedSendCodeToConfirm] =
    useState(false);
  const [isCheckedSendReminder, setIsCheckedSendReminder] = useState(false);

  const [countryCode, setCountryCode] = useState("us");
  const [countryCodeNumber, setCountryCodeNumber] = useState("351");
  const [phone, setPhone] = useState("");
  const [phoneWithoutCountryCode, setPhoneWithoutCountryCode] = useState("");
  const [whatSappToken, setWhatSappToken] = useState("");

  const [emailNotifications, setEmailNotifications] = useState({});
  const [WhatsappNotifications, setWhatsappNotifications] = useState({});

  const notifications_list = useSelector(
    (state) => state.restaurantNotifications
  );
  const {
    restaurantNotifications,
    isLoadingRestaurantNotifications,
    restaurantNotificationsError,
  } = notifications_list;

  const restaurant_info = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurant_info;
  const [isPhoneValid, setIsPhoneValid] = useState(false);

  useEffect(() => {
    if (restaurants) {
      setRestaurant_id(restaurants.id);
    }
  }, [restaurants]);

  useEffect(() => {
    dispatch(getRestaurantNotificationsList(restaurant_id));
    //dispatch(fetchRestaurantDetails(restaurant_id));
  }, [restaurant_id]);

  useEffect(() => {
    const timer = setInterval(() => {
      dispatch(getRestaurantNotificationsList(restaurant_id));
    }, 15000);
    return () => clearInterval(timer);
  }, [dispatch, restaurant_id]);

  useEffect(() => {
    if (restaurantNotifications) {
      const whatsappFiltered = restaurantNotifications.filter(
        (notification) => notification.phone_number !== ""
      );
      const emailFiltered = restaurantNotifications.filter(
        (notification) => notification.email !== ""
      );
      setWhatsappNotifications(whatsappFiltered);
      setEmailNotifications(emailFiltered);
    }
  }, [restaurantNotifications]);

  useEffect(() => {
    if (countryCodeNumber === "") {
      const detectedCountryCode = detectCountryCode();
      setCountryCode(detectedCountryCode);
      setCountryCodeNumber(getDialCode(detectedCountryCode));
    } else {
      setCountryCode(getCountryCode(countryCodeNumber));
    }
  }, [countryCodeNumber]);

  const detectCountryCode = () => {
    const userCountryCode = navigator.language.split("-")[1];
    const formattedCountryCode = userCountryCode
      ? userCountryCode.toLowerCase()
      : "us";
    // Add more specific checks if needed based on the origin or location detection mechanism
    return formattedCountryCode; // Default to 'PT' if the country code is not detected
  };

  useEffect(() => {
    // Check if countryCode and phone are not null or undefined before concatenating
    if (countryCodeNumber && phoneWithoutCountryCode) {
      setPhone(String(countryCodeNumber) + String(phoneWithoutCountryCode));
    }
  }, [phoneWithoutCountryCode, countryCodeNumber]);

  const MAX_CHARACTER_LIMIT = 10;

  const handleInputPhoneChange = (e) => {
    const inputValue = e.target.value;

    if (inputValue.length <= MAX_CHARACTER_LIMIT) {
      setPhoneWithoutCountryCode(inputValue);
    }
  };

  const handleUpdate = () => {
    setUpdate_or_create("update");
    if (phone !== "") {
      let phoneWithoutCountryCoda;
      if (phone.length > 5) {
        const countryCodeLength = countryCodeNumber.length;
        let phoneNumber = phone;

        // Remove leading plus if it exists
        if (phoneNumber[0] === "+") {
          phoneNumber = phoneNumber.slice(1);
        }

        // Remove leading country code number
        phoneWithoutCountryCoda = phoneNumber.slice(countryCodeLength);
      }
      setIsWaiting(true);
      setShowModal(false);
      setTimeout(() => {
        setIsWaiting(false);
      }, 1500);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\d{7,15}$/; // Allows 7 to 15 digits
    return phoneRegex.test(phoneNumber);
  };

  const handleCreate = () => {
    let params;

    if (email_or_whatsapp === "email") {
      if (email.trim() === "") {
        setEmailWM(true);
        return;
      }
      if (!validateEmail(email)) {
        alert("Formato de e-mail inválido! Por favor insira um e-mail válido.");
        setEmailWM(true);
        return;
      }

      setEmailWM(false);
      setIsWaiting(true);

      params = {
        restaurant: parseInt(restaurant_id, 10),
        email,
        name,
        phone_number: "",
        country_code: "",
        getEmails: true,
        getWhatsappNotifications: false,
        whatsapp_notification_token: "",
        isItConfirmed: false,
      };

      dispatch(createRestaurantNotificationsList(restaurant_id, params));
      setShowModal(false);

      setTimeout(() => {
        setIsWaiting(false);
        setShowWarningModal(true);
      }, 1500);
      return;
    }

    if (email_or_whatsapp === "whatsapp") {
      if (phoneWithoutCountryCode.trim() === "") {
        setPhoneWM(true);
        return;
      }
      if (!isPhoneValid) {
        alert("Número de telemóvel inválido! Verifique e tente novamente.");
        setPhoneWM(true);
        return;
      }

      setPhoneWM(false);
      setIsWaiting(true);

      params = {
        restaurant: parseInt(restaurant_id, 10),
        email: "",
        name,
        phone_number: phoneWithoutCountryCode,
        country_code: countryCodeNumber,
        getEmails: false,
        getWhatsappNotifications: true,
        whatsapp_notification_token: whatSappToken,
        isItConfirmed: false,
      };

      dispatch(createRestaurantNotificationsList(restaurant_id, params));
      setShowModal(false);

      setTimeout(() => {
        setIsWaiting(false);
        setShowWarningModal(true);
      }, 1500);
    }
  };

  const handleShowModal = (
    create_what,
    create_or_update,
    item_id,
    item_phone,
    item_email,
    item_whatsapp_token
  ) => {
    if (create_or_update === "create") {
      setItemId("");
      setPhone("");
      setPhoneWithoutCountryCode("");
      setEmail("");
      setName("");
      setWhatSappToken("");
      setUpdate_or_create("create");
    } else {
      setItemId(item_id);
      setPhone(item_phone);
      setPhoneWithoutCountryCode(item_phone);
      setEmail(item_email);
      setWhatSappToken(item_whatsapp_token);
      setUpdate_or_create("update");
    }
    if (create_what === "whatsapp") {
      setEmail_or_whatsapp("whatsapp");
    } else {
      setEmail_or_whatsapp("email");
    }
    setShowModal(true);
  };

  const handleDeleteModalOpen = (value) => {
    const item = restaurantNotifications.find((n) => n.id === value);

    if (item?.email) {
      setEmail_or_whatsapp("email");
    } else if (item?.phone_number) {
      setEmail_or_whatsapp("whatsapp");
    }

    setItemId(value);
    setShowDeleteModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handleExceptionElimination = async () => {
    setIsWaiting(true);
    setTimeout(() => {
      setIsWaiting(false);
    }, 1500);
    try {
      const response = await api.delete(
        `/restaurants/${restaurant_id}/restaurant_notifications/${itemId}/`
      );
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }
    setShowDeleteModal(false);
    dispatch(getRestaurantNotificationsList(restaurant_id));
  };

  const handleUseEmail = () => setUseEmail((prevState) => !prevState);
  const handleUseSms = () => setUseSms((prevState) => !prevState);
  const handleUseWhatsapp = () => setUseWhatsapp((prevState) => !prevState);

  useEffect(() => {
    console.log("useEmail: ", useEmail);
    console.log("useWhatsapp: ", useWhatsapp);
    console.log("useSms: ", useSms);
    console.log("name: ", name);
  }, [useEmail, useWhatsapp, useSms, name]);

  return (
    <>
      {/* WhatsApp */}
      <Wrapper>
        <WrapperHeader>
          <HeaderLeft>
            <FontAwesomeIcon size="xl" icon={faWhatsapp} />
            <HeaderText>
              <HeaderTitle>Números de telemóvel associados</HeaderTitle>
              <HeaderSub>
                Estes contactos irão receber notificações sobre a gestão das
                reservas pelo WhatsApp.
              </HeaderSub>
            </HeaderText>
          </HeaderLeft>
          <HeaderRight>
            <CreateButton onClick={() => handleShowModal("whatsapp", "create")}>
              <FontAwesomeIcon size="xl" icon={faPlus} />
            </CreateButton>
          </HeaderRight>
        </WrapperHeader>
        <WrapperBot>
          {WhatsappNotifications.length > 0 ? (
            WhatsappNotifications.map((notification) => (
              <B2 key={notification.id}>
                <B2Top>
                  <ZoneTitle>
                    {notification.name +
                      "   " +
                      "(" +
                      notification.phone_number +
                      ")"}
                  </ZoneTitle>
                  <TrashButton
                    onClick={() => handleDeleteModalOpen(notification.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </TrashButton>
                </B2Top>
                <WrapperBot>
                  <h5
                    style={{
                      fontSize: "16px",
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    Estado:{" "}
                    {notification.isItConfirmed === true ? (
                      <div
                        style={{
                          color: "green",
                          width: "auto",
                          paddingLeft: "10px",
                        }}
                      >
                        Associado
                      </div>
                    ) : (
                      <div
                        style={{
                          color: "#b5af04",
                          width: "auto",
                          paddingLeft: "10px",
                        }}
                      >
                        Aguarda confirmação
                      </div>
                    )}
                  </h5>
                </WrapperBot>
              </B2>
            ))
          ) : (
            <> Nenhum número de telemóvel (WhatsApp) associado </>
          )}
        </WrapperBot>
      </Wrapper>

      {/* Email Notifications */}
      <Wrapper>
        <WrapperHeader>
          <HeaderLeft>
            <FontAwesomeIcon size="xl" icon={faEnvelope} />
            <HeaderText>
              <HeaderTitle>Endereços de e-mail associados</HeaderTitle>
              <HeaderSub>
                Estes contactos irão receber notificações sobre a gestão das
                reservas pelo e-mail.
              </HeaderSub>
            </HeaderText>
          </HeaderLeft>
          <HeaderRight>
            <CreateButton onClick={() => handleShowModal("email", "create")}>
              <FontAwesomeIcon size="xl" icon={faPlus} />
            </CreateButton>
          </HeaderRight>
        </WrapperHeader>

        <WrapperBot>
          {emailNotifications.length > 0 ? (
            emailNotifications.map((notification) => (
              <B2 key={notification.id}>
                <B2Top>
                  <ZoneTitle>
                    {notification.name} ({notification.email})
                  </ZoneTitle>
                  <TrashButton
                    onClick={() => handleDeleteModalOpen(notification.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </TrashButton>
                </B2Top>

                <WrapperBot>
                  <h5
                    style={{
                      fontSize: "16px",
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    Estado:&nbsp;
                    {notification.isItConfirmed ? (
                      <span style={{ color: "green" }}>Confirmado</span>
                    ) : (
                      <span style={{ color: "#b5af04" }}>
                        Aguarda confirmação
                      </span>
                    )}
                  </h5>
                </WrapperBot>
              </B2>
            ))
          ) : (
            <>Nenhum e-mail associado </>
          )}
        </WrapperBot>
      </Wrapper>

      <CustomModal
        show={showModal}
        onHide={handleClose}
        title={
          email_or_whatsapp === "whatsapp"
            ? "Associar novo número de telemóvel"
            : "Associar novo endereço de e-mail"
        }
        footer={
          <>
            <ModernButton color="#99b0ad" onClick={handleClose}>
              Cancelar
            </ModernButton>
            {update_or_create === "create" ? (
              <ModernButton color="#EE754C" onClick={handleCreate}>
                Associar
              </ModernButton>
            ) : (
              <ModernButton color="#EE754C" onClick={handleUpdate}>
                Gravar
              </ModernButton>
            )}
          </>
        }
      >
        <div style={{ fontSize: "15px", lineHeight: "1.6", color: "#444" }}>
          <Form>
            <Form.Group style={{ marginBottom: "20px" }}>
              <label
                style={{
                  fontWeight: 500,
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                Nome
              </label>
              <ModernTextInput
                type="text"
                placeholder="Nome"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>

            {email_or_whatsapp === "email" ? (
              <Form.Group style={{ marginBottom: "15px" }}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: "6px",
                    display: "block",
                  }}
                >
                  E-mail
                </label>
                <div style={{ position: "relative" }}>
                  <StyledInput
                    type="email"
                    placeholder="email@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{ paddingLeft: "59px" }}
                  />
                  <AbsoluteKeySquare>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ color: "#EE754C" }}
                    />
                  </AbsoluteKeySquare>
                </div>
                {emailWM && (
                  <p style={{ color: "red", marginTop: "5px" }}>
                    Por favor preencher um endereço de e-mail válido.
                  </p>
                )}
              </Form.Group>
            ) : (
              <Form.Group style={{ marginBottom: "15px" }}>
                <label
                  style={{
                    fontWeight: 500,
                    marginBottom: "6px",
                    display: "block",
                  }}
                >
                  Telemóvel
                </label>
                <div style={{ position: "relative", marginTop: "8px" }}>
                  <PhoneField
                    countryCodeNumber={countryCodeNumber}
                    setCountryCodeNumber={setCountryCodeNumber}
                    phoneWithoutCountryCode={phoneWithoutCountryCode}
                    setPhoneWithoutCountryCode={setPhoneWithoutCountryCode}
                    isPhoneValid={isPhoneValid}
                    setIsPhoneValid={setIsPhoneValid}
                    initialFullPhone={phone}
                  />
                </div>
                {phoneWM && (
                  <p style={{ color: "red", marginTop: "5px" }}>
                    Por favor preencher um número de telemóvel
                  </p>
                )}
              </Form.Group>
            )}
          </Form>
        </div>
      </CustomModal>

      <ConfirmationModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleExceptionElimination}
        title={
          email_or_whatsapp === "whatsapp"
            ? "Eliminar número de telemóvel"
            : "Eliminar endereço de e-mail"
        }
        body={
          email_or_whatsapp === "whatsapp"
            ? "Tens a certeza que pretendes deixar de receber notificações neste número?"
            : "Tens a certeza que pretendes deixar de receber notificações neste e-mail?"
        }
        cancelLabel="Cancelar"
        confirmLabel="Eliminar"
        confirmColor="#EE754C"
        cancelColor="#99b0ad"
      />

      <CustomModal
        show={showWarningModal}
        onHide={() => setShowWarningModal(false)}
        title={
          email_or_whatsapp === "whatsapp"
            ? "Confirmar número de telemóvel"
            : "Confirmar endereço de e-mail"
        }
        footer={
          <ModernButton
            color="#EE754C"
            onClick={() => setShowWarningModal(false)}
          >
            OK
          </ModernButton>
        }
      >
        <div style={{ fontSize: "15px", lineHeight: "1.6", color: "#444" }}>
          <p>
            {email_or_whatsapp === "whatsapp"
              ? "Este contacto vai receber um link pelo WhatsApp para confirmar a associação às notificações."
              : "Este contacto vai receber um link por e-mail para confirmar a associação às notificações."}
          </p>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "12px 0",
              fontSize: "16px",
              fontWeight: "500",
              color: "#333",
            }}
          >
            <FontAwesomeIcon
              icon={
                email_or_whatsapp === "whatsapp"
                  ? faSquarePhoneFlip
                  : faEnvelope
              }
              style={{
                color: "#EE754C",
                marginRight: "10px",
                fontSize: "20px",
              }}
            />
            {email_or_whatsapp === "whatsapp" ? `+${phone}` : email}
          </div>

          <p style={{ marginTop: "20px" }}>
            {email_or_whatsapp === "whatsapp"
              ? "Caso o número esteja incorreto, por favor apaga e tenta novamente."
              : "Caso o endereço esteja incorreto, por favor apaga e tenta novamente."}
          </p>
        </div>
      </CustomModal>

      {isWaiting && <WaitCheckMark />}
    </>
  );
}

export default RestaurantNotifications;

const Buttoni = styled.button`
  padding: 5px 8px;
  background-color: #007bff;
  color: white;
  font-size: 14px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056b3;
  }
`;

const Wrapper = styled.div`
  position: relative;
  margin: 10px 0;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  border: 1px solid #e8e6e1;
  background: white;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const StyledInput = styled(Form.Control)`
  &:focus {
    border-color: #ee754c !important;
    box-shadow: 0 0 0 0.2rem rgba(238, 117, 76, 0.25) !important;
  }
`;

const AbsoluteKeySquare = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px 0 0 4px;
  background-color: #f2f2f2;
  border: solid 1px #cfcfcf;
  top: 0;
  left: 0;
  width: 50px;
  height: 38px;
  font-size: 18px;

  &:hover {
    background-color: #e8e8e8;
    border-color: #76d6c5;
  }
`;

const WrapperHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  background-color: #98afad;
  color: #ede5d2;
  border-radius: 6px 6px 0 0;
  flex-wrap: nowrap;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1 1 auto;

  svg {
    flex: 0 0 auto;
    margin-top: 0;
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const HeaderTitle = styled.div`
  font-size: 17px;
  font-weight: 600;
  line-height: 1.2;
  white-space: normal;
  word-break: break-word;
`;

const HeaderSub = styled.div`
  font-size: 12px;
  opacity: 0.95;
  line-height: 1.35;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

const CreateButton = styled.button`
  padding: 6px 8px;
  background-color: #ee754c;
  color: #fff;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: #ee561b;
  }
`;

const B2 = styled.div`
  background-color: #f8f9fa;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  margin-bottom: 10px;
  position: relative;
`;

const B2Top = styled.div`
  background-color: #98afad;
  color: #ede5d2;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 40px;
  border-radius: 6px 6px 0 0;
`;

const ZoneTitle = styled.h2`
  color: #ede5d2;
  font-size: 16px;
  line-height: 1.25;
  margin: 0;
  overflow-wrap: anywhere;
  word-break: break-word;

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

const WrapperBot = styled.div`
  padding: 10px;
`;

const TrashButton = styled.button`
  border: 0;
  background: transparent;
  color: #ede5d2;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 4px 6px;
  border-radius: 4px;

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }
`;
